<template>
    <div id="news_edit">
        <h1 class="title">Редактор новостей</h1>
        <button style="margin: 1.5% 0% 0% 0%;" @click="showNewRecord = true" class="btn btn-outline-primary">Создать
            новость</button>
        <button style="margin: 1.5% 0% 0% 1.5%;" @click="showSearchRecord = true" class="btn btn-outline-primary">Найти
            новость</button>

        <div v-if="this.newAdded" style="margin-top: 1.5%;" class="w-25 alert alert-success" role="alert">
            Данные успешно сохранены!
        </div>

        <div v-if="showNewRecord" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Создать новую запись</h5>
                        <button @click="showNewRecord = false; invalid = []; newAdded = false" type="button"
                            class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>

                    <form id="NewRecordForm" :action="createRecord" method="POST" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div v-if="this.newAdded" class="alert alert-success" role="alert">
                                Данные успешно сохранены!
                            </div>
                            <div class="mb-3">
                                <label for="title" class="form-label">Заголовок:</label>
                                <input type="text"
                                    :class="'form-control ' + (!!~invalid.indexOf('title') ? 'is-invalid' : '')"
                                    id="title" name="title" ref="title" placeholder="Заголовок" aria-label="Заголовок"
                                    aria-describedby="basic-addon1">
                                <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                    Заполните поле
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="text" class="form-label">Текст:</label>
                                <textarea :class="'form-control ' + (!!~invalid.indexOf('text') ? 'is-invalid' : '')"
                                    id="text" name="text" ref="text" placeholder="Текст" aria-label="Текст"
                                    aria-describedby="basic-addon1"></textarea>
                                <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                    Заполните поле
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="files" class="form-label">Изображения:</label>
                                <input :class="'form-control ' + (!!~invalid.indexOf('files') ? 'is-invalid' : '')"
                                    ref="file" type="file" id="formFileMultiple file files" name="files"
                                    aria-describedby="inputGroupFileAddon04" aria-label="Загрузка"
                                    accept=".jpg,.jpeg,.png" multiple>
                                <div id="validationServerFilesFeedback" class="invalid-feedback">
                                    Прикрепите файлы
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="date" class="form-label">Дата публикации:</label>
                                <input type="date" name="date"
                                    :class="'form-control ' + (!!~invalid.indexOf('date') ? 'is-invalid' : '')"
                                    id="date" ref="date" :min="mmDate[0]" :max="mmDate[1]" />
                                <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                    Заполните поле
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click.prevent="createNewRecord" type="submit" class="btn btn-primary"
                                id="nd_sub">Добавить
                                новость</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div v-if="showSearchRecord" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Редактор новостей</h5>
                        <button
                            @click="showSearchRecord = false; invalid = []; newAdded = false; showResults = 0; selectRecord = []; selectTitle = 'Выберите заголовок искомой статьи'"
                            type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>

                    <div class="modal-body">
                        <h5>Задайте временной промежуток поиска записи:</h5>
                        <div class="mb-3">
                            <label for="date" class="form-label">Начальная дата:</label>
                            <input type="date" name="Sdate"
                                :class="'form-control ' + (!!~invalid.indexOf('Sdate') ? 'is-invalid' : '')" id="Sdate"
                                ref="Sdate" min="2020-02-23" :max="mmDate[1]" />
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Заполните поле
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="date" class="form-label">Конечная дата:</label>
                            <input type="date" name="Edate"
                                :class="'form-control ' + (!!~invalid.indexOf('Edate') ? 'is-invalid' : '')" id="Edate"
                                ref="Edate" min="2020-02-23" :max="mmDate[1]" />
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Заполните поле
                            </div>
                        </div>
                        <div class="mb-3">
                            <button @click="searchRecord" type="submit" class="btn btn-primary"
                                id="nd_sub">Поиск</button>
                        </div>
                        <div v-if="showResults == 1" class="mb-3">
                            <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" ref="titleName" type="button"
                                    id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    {{ selectTitle }}
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li v-for="(r, n) in results" :key="n"><a
                                            @click="selectTitle = r[1]; selectRecord = r" class="dropdown-item"
                                            href="#">{{ r[1] }}</a></li>
                                </ul>
                            </div>
                        </div>
                        <h5 v-if="showResults == 2">Ничего не найдено</h5>

                        <div v-if="selectRecord.length > 0">
                            <hr class="hr" />
                            <form id="EditRecordForm" :action="editRecord" method="POST" enctype="multipart/form-data">
                                <div class="mb-3">
                                    <label for="title" class="form-label">Заголовок:</label>
                                    <input type="text"
                                        :class="'form-control ' + (!!~invalid.indexOf('Ntitle') ? 'is-invalid' : '')"
                                        id="title" name="title" ref="Ntitle" placeholder="Заголовок"
                                        aria-label="Заголовок" aria-describedby="basic-addon1" :value="selectRecord[1]">
                                    <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                        Заполните поле
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="text" class="form-label">Текст:</label>
                                    <textarea
                                        :class="'form-control ' + (!!~invalid.indexOf('Ntext') ? 'is-invalid' : '')"
                                        id="text" name="text" ref="Ntext" placeholder="Текст" aria-label="Текст"
                                        aria-describedby="basic-addon1" :value="selectRecord[2]"></textarea>
                                    <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                        Заполните поле
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="files" class="form-label">Изображения:</label>
                                    <div v-for="(id, n) in selectRecord[4]" :key="n">
                                        <label for="files" class="form-label">Картинка {{ id }}:</label>
                                        <img :src="'https://api.bormart.ru/nws_img/?id=' + id"
                                            class="d-block w-100 news_img" alt="img">
                                    </div>
                                    <div style="margin-top: 2%;" class="dropdown">
                                        <button data-mdb-button-init data-mdb-ripple-init data-mdb-dropdown-init
                                            class="btn btn-outline-secondary dropdown-toggle" type="button"
                                            id="dropdownMenuButton" data-mdb-toggle="dropdown" aria-expanded="false"
                                            data-bs-toggle="dropdown">
                                            Выбрать оставляемые картинки
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton" ref="Ndropdown">
                                            <li v-for="(id, n) in selectRecord[4]" :key="n">
                                                <a class="dropdown-item" href="#">
                                                    <div class="form-check">
                                                        <input class="form-check-input" :name="'img_' + id"
                                                            type="checkbox" :value="id" :id="id" checked />
                                                        <label class="form-check-label" :for="'role' + j">Картинка {{ id
                                                            }}</label>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <label for="files" class="form-label">Догрузить:</label>
                                    <input :class="'form-control ' + (!!~invalid.indexOf('Nfiles') ? 'is-invalid' : '')"
                                        ref="Nfile" type="file" id="formFileMultiple file files" name="files"
                                        aria-describedby="inputGroupFileAddon04" aria-label="Загрузка"
                                        accept=".jpg,.jpeg,.png" multiple>
                                    <div id="validationServerFilesFeedback" class="invalid-feedback">
                                        Прикрепите файлы
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="date" class="form-label">Дата публикации:</label>
                                    <input type="date" name="date"
                                        :class="'form-control ' + (!!~invalid.indexOf('Ndate') ? 'is-invalid' : '')"
                                        id="date" ref="Ndate" :value="selectRecord[3]" :min="mmDate[0]"
                                        :max="mmDate[1]" />
                                    <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                        Заполните поле
                                    </div>
                                </div>
                                <button @click.prevent="saveRec" type="submit" class="btn btn-success"
                                    id="save">Сохранить
                                    изменения</button>
                                <button @click="acceptDel = true" style="margin-left: 1.5%; margin-top: 1.5%;" type="button"
                                    class="btn btn-danger" id="del">Удалить
                                    новость</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div v-if="acceptDel" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
        role="dialog" style="display:block">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Удаление новости</h5>
                    <button type="button" @click="acceptDel = false" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Закрыть"></button>
                </div>
                <div class="modal-body">
                    <p>Вы уверены, что хотите удалить новость "{{ selectTitle }}"?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" @click="acceptDel = false" class="btn btn-success">Оставить</button>
                    <button type="button" @click="deleteRec" class="btn btn-danger">Удалить</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewsEdit",
    computed: {
        mmDate() {
            var today = new Date()
            var dd = String(today.getDate()).padStart(2, '0')
            var mm = String(today.getMonth() + 1).padStart(2, '0')
            var yyyy = today.getFullYear()
            return [yyyy + "-" + mm + "-" + dd, (yyyy + 5) + "-" + mm + "-" + dd]
        }
    },
    data() {
        return {
            createRecord: 'https://api.bormart.ru/add_news_record',
            editRecord: 'https://api.bormart.ru/edit_rec',
            searchRecordURL: 'https://api.bormart.ru/search_record',
            deleteRecordURl: 'https://api.bormart.ru/delete_record',
            showNewRecord: false,
            showSearchRecord: false,
            newAdded: false,
            acceptDel: false,
            showResults: 0,
            selectRecord: [],
            selectTitle: 'Выберите заголовок искомой статьи',
            invalid: [],
            results: []
        }
    },
    methods: {
        saveRec() {
            const form = document.getElementById('EditRecordForm')
            if (this.$refs.Ntext.value.length == 0) {
                this.invalid.push('Ntext')
            }
            if (this.$refs.Ntitle.value.length == 0) {
                this.invalid.push('Ntitle')
            }
            if (this.$refs.Ndate.value.length == 0) {
                this.invalid.push('Ndate')
            }
            if (this.invalid.length > 0) {
                return
            }
            this.invalid = []
            let data = new FormData(form)
            data.append('id', this.selectRecord[0])
            fetch(form.action, {
                credentials: "include",
                method: form.method,
                body: data
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.newAdded = true
                }
            })
        },
        createNewRecord() {
            const form = document.getElementById('NewRecordForm')
            if (this.$refs.file.files.length == 0) {
                this.invalid.push('files')
            }
            if (this.$refs.text.value.length == 0) {
                this.invalid.push('text')
            }
            if (this.$refs.title.value.length == 0) {
                this.invalid.push('title')
            }
            if (this.$refs.date.value.length == 0) {
                this.invalid.push('date')
            }
            if (this.invalid.length > 0) {
                return
            }
            this.invalid = []
            fetch(form.action, {
                credentials: "include",
                method: form.method,
                body: new FormData(form)
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.newAdded = true
                }
            })
        },
        searchRecord() {
            const Sdate = this.$refs.Sdate.value
            const Edate = this.$refs.Edate.value
            if (Sdate.length == 0) {
                this.invalid.push('Sdate')
            }
            if (Edate.length == 0) {
                this.invalid.push('Edate')
            }
            if (this.invalid.length > 0) {
                return
            }
            this.invalid = []
            fetch(this.searchRecordURL, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({
                    "Sdate": Sdate,
                    "Edate": Edate
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.results = data["recs"]
                    if (this.results.length > 0) {
                        this.showResults = 1
                    } else {
                        this.showResults = 2
                    }
                }
            })
        },
        deleteRec() {
            fetch(this.deleteRecordURl + "?id=" + this.selectRecord[0], {
                credentials: "include"
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.newAdded = true
                }
            })
            this.acceptDel = false
            this.showSearchRecord = false
            this.invalid = []
            this.newAdded = false
            this.showResults = 0
            this.selectRecord = []
            this.selectTitle = 'Выберите заголовок искомой статьи'
        }
    }
}
</script>